import React from 'react';

interface LogoProps {
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ className = '' }) => {
  return (
    <svg className={className} viewBox="0 0 434.89 131.1">
      <g>
        <path
          className="fill-slate-800 dark:fill-gray-50"
          d="M2.89,18.57L52.78,7.35c.42-.09,1.11-.1,1.53,0l50.46,11.25c.82.18,1.41.91,1.41,1.75v41.17c0,.99-.75,2.03-1.75,2.03l-17.47.04c-.61,0-1.17-.3-1.5-.81l-6-10.31c-2.51-4.33-10.05-2.29-10.97,3.17l-5.43,21.56c-.1.39-.66.4-.76,0-1.78-6.66-9.01-34.63-10.83-41.5-1-3.77-7.46-3.34-8.74.27-.84,2.38-7.61,28.68-9.1,34.65-.09.37-.61.41-.75.05-1.07-2.73-4.04-10.26-4.49-11.35-1.4-3.34-6.74-4.04-9.07-.95-.75.99-2.01,2.78-3.12,3.92-.25.25-1.31,1.05-1.87,1.08l-11.27.12c-1.02.04-1.88-.77-1.88-1.8V20.71c0-1.03.71-1.92,1.72-2.14Z"
        />
        <path
          className="fill-blue-500 dark:fill-blue-400"
          d="M2.91,69.68s8.61-.02,8.68-.02c2.27.02,6.53.46,10.41-5.96.31-.5.56-.53.8.17.36,1.04,3.62,8.38,5.28,11.4,2.17,3.96,9.36,4.16,10.78-1.25.77-2.93,5.47-20.64,7.62-28.7.34-1.26,1.05-1.26,1.37,0,0,0,8.84,35.81,9.85,39.36,1.85,6.2,8.58,5.96,10.29-1.05,1.52-6.24,6-24.09,6.45-26.04.08-.33.35-.39.54.05,3.51,8.29,4.02,12,13.06,11.93,6.38-.05,12.85-.04,16.61,0,.76,0,.73.39.62,1.16-3.7,20.87-20.14,38.61-50.14,52.69-1.12.53-1.73.39-2.58,0C23.8,110.24,6.98,94.41,1.35,71.18c-.29-1.2.14-1.49,1.57-1.5Z"
        />
      </g>
      <g>
        <polygon
          className="fill-slate-800 dark:fill-gray-50 stroke-slate-800 dark:stroke-fill-gray-50"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="185 35.86 164.67 83.41 144.35 35.86 132.18 35.86 159.68 97.61 169.23 97.61 196.73 35.86 185 35.86"
        />
        <path
          className="fill-slate-800 dark:fill-gray-50 stroke-slate-800 dark:stroke-fill-gray-50"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M221.17,55.22c-2.86-1.81-6.42-2.72-10.69-2.72s-8.1.96-11.34,2.89c-3.24,1.93-5.77,4.61-7.58,8.06-1.81,3.45-2.72,7.48-2.72,12.09,0,7.12,2.1,12.73,6.31,16.82,4.2,4.09,10.01,6.13,17.43,6.13,3.27,0,6.36-.47,9.28-1.4,2.92-.93,5.43-2.25,7.53-3.94l-3.24-7.36c-1.99,1.52-4.07,2.61-6.26,3.28-2.19.67-4.54,1.01-7.05,1.01-4.32,0-7.66-1.18-10.03-3.55-2.13-2.13-3.29-5.24-3.5-9.33h30.61v-2.89c0-4.38-.74-8.2-2.23-11.47-1.49-3.27-3.67-5.81-6.53-7.62ZM199.45,71.42c.36-3.09,1.28-5.6,2.75-7.53,1.96-2.57,4.74-3.85,8.36-3.85,3.27,0,5.77,1.08,7.49,3.24,1.54,1.94,2.39,4.66,2.55,8.15h-21.16Z"
        />
        <path
          className="fill-slate-800 dark:fill-gray-50 stroke-slate-800 dark:stroke-fill-gray-50"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M259.53,52.51c-2.34,0-4.5.47-6.48,1.4-1.99.93-3.67,2.36-5.04,4.29-.63.88-1.16,1.87-1.62,2.96l-.79-7.77h-10.6c.23,1.81.39,3.68.48,5.61.09,1.93.13,3.83.13,5.69v32.93h11.04v-23.56c0-2.39.42-4.52,1.27-6.39.85-1.87,2.13-3.33,3.85-4.38,1.72-1.05,3.84-1.58,6.35-1.58,1.17,0,2.15.06,2.93.17.79.12,1.74.41,2.85.88l.09-9.63c-.64-.23-1.29-.39-1.93-.48-.64-.09-1.49-.13-2.54-.13Z"
        />
        <rect
          className="fill-slate-800 dark:fill-gray-50 stroke-slate-800 dark:stroke-fill-gray-50"
          strokeLinecap="round"
          strokeLinejoin="round"
          x="267.76"
          y="34.37"
          width="12.17"
          height="10.69"
        />
        <rect
          className="fill-slate-800 dark:fill-gray-50 stroke-slate-800 dark:stroke-fill-gray-50"
          strokeLinecap="round"
          strokeLinejoin="round"
          x="268.38"
          y="53.38"
          width="10.95"
          height="44.23"
        />
        <polygon
          className="fill-slate-800 dark:fill-gray-50 stroke-slate-800 dark:stroke-fill-gray-50"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="337.39 35.86 317.07 83.41 296.75 35.86 284.58 35.86 312.08 97.61 321.63 97.61 349.13 35.86 337.39 35.86"
        />
        <path
          className="fill-slate-800 dark:fill-gray-50 stroke-slate-800 dark:stroke-fill-gray-50"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M383.24,63.23c-1.84-3.42-4.44-6.06-7.8-7.93-3.36-1.87-7.31-2.8-11.87-2.8s-8.5.93-11.82,2.8c-3.33,1.87-5.91,4.51-7.75,7.93-1.84,3.42-2.76,7.49-2.76,12.22s.92,8.82,2.76,12.26c1.84,3.45,4.42,6.1,7.75,7.97,3.33,1.87,7.27,2.8,11.82,2.8s8.51-.93,11.87-2.8c3.36-1.87,5.96-4.52,7.8-7.97,1.84-3.44,2.76-7.53,2.76-12.26s-.92-8.8-2.76-12.22ZM371.81,86.44c-2.04,2.42-4.79,3.63-8.23,3.63s-6.19-1.21-8.23-3.63c-2.04-2.42-3.07-6.09-3.07-10.99s1.02-8.55,3.07-10.95c2.04-2.39,4.79-3.59,8.23-3.59s6.19,1.2,8.23,3.59c2.04,2.4,3.07,6.04,3.07,10.95s-1.02,8.57-3.07,10.99Z"
        />
        <polygon
          className="fill-slate-800 dark:fill-gray-50 stroke-slate-800 dark:stroke-fill-gray-50"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="415.17 74.79 432.42 53.38 419.55 53.38 408.82 67.22 398.09 53.38 385.13 53.38 402.54 74.8 383.99 97.61 396.95 97.61 408.81 82.52 420.6 97.61 433.65 97.61 415.17 74.79"
        />
      </g>
    </svg>
  );
};

export default Logo;
